<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="form-section">
        <i class="ft-repeat"></i> Module Details</h4>
    </div>
    <div class="card-body">
      <div class="px-3">

        <!-- ModuleId -->
        <div class="card-field">
          <div class="card-field-label">Module Id:</div>
          <div class="card-field-content">{{ currentObject.ModuleId }}</div>
        </div>

        <!-- Name -->
        <div class="card-field">
          <div class="card-field-label">Name:</div>
          <div class="card-field-content">{{ currentObject.Name }}</div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary btn-raised mr-1 float-right" (click)="closeModal()"><i
            class="ft-x-square"></i> Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
